import type { TRawPublication } from 'config/entities'

import type { TPublication } from 'modules/publication/types'

export const isPublicationPublished = (publication: TPublication | TRawPublication) =>
  publication ? !publication.isDraft && !(publication.isScheduled && !publication.published) : true
